import { Routes, Route, Link, Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ user, redirectPath = "/login", children }) => {
  // Dok provera prijave traje (user === null) ne preusmeravamo — u suprotnom
  // bi zaštićena strana pri svakom učitavanju prvo završila na redirectPath
  // i taj unos bi ostao u istoriji pretraživača.
  if (user === null) {
    return null;
  }

  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
